import { api, clearTokens, refreshAccessToken, SECURE_SESSION, unwrapClientError } from './api';
import { useAuthStore, type User } from '@/stores/authStore';

/** Storage is only a UI cache; the refresh cookie proves the session. */
export async function restoreSecureSession(): Promise<void> {
  const auth = useAuthStore.getState();
  if (!SECURE_SESSION) return;
  try {
    const status = await api.get<{ hasSession: boolean }>('/auth/session-status');
    if (!status.data.hasSession) {
      if (auth.isAuthenticated) { clearTokens(); auth.logout(); }
      return;
    }
    await refreshAccessToken();
    const { data: user } = await api.get<User>('/auth/me');
    auth.setUser(user);
    if (user.tenantId) auth.setTenantId(user.tenantId);
  } catch (error) {
    const raw = unwrapClientError(error) as { response?: { status?: number } };
    if (raw?.response?.status !== 401 && raw?.response?.status !== 403) throw error;
    clearTokens();
    auth.logout();
  }
}
